import { createAction, props } from '@ngrx/store';
import type { IOneCalcResponseV2 } from 'fcis-widget/dist/types/interfaces/IOneCalcResponseV2';

export enum FinancingActionType {
  UpdateIsFcisInitialized = '[Financing] is Fcis initialized',
  UpdateIsFcisWidgetOpen = '[Financing] is Fcis widget open',
  UpdateIsFcisRateConfirmed = '[Financing] confirm Fcis rate',
  UpdateFcisRateInfo = '[Financing] update Fcis rate info',
  UpdateFcisCalculationResult = '[Financing] update Fcis calculation result',
  UpdateIsFcisResultAvailable = '[Financing] has Fcis returned a valid result',
  UpdateOnFcisError = '[Financing] has Fcis returned an error',
  FetchFcisVersion = '[Financing] fetch Fcis version'
}

export const financingUpdateIsFcisInitialized = createAction(FinancingActionType.UpdateIsFcisInitialized);

export const financingUpdateIsFcisWidgetOpen = createAction(
  FinancingActionType.UpdateIsFcisWidgetOpen,
  props<{ isFcisWidgetOpen: boolean }>()
);

export const financingUpdateIsFcisRateConfirmed = createAction(
  FinancingActionType.UpdateIsFcisRateConfirmed,
  props<{ isFcisRateConfirmed: boolean }>()
);

export const financingUpdateFcisCalculationResult = createAction(
  FinancingActionType.UpdateFcisCalculationResult,
  props<{ calculationResult: IOneCalcResponseV2 }>()
);

export const financingUpdateIsFcisResultAvailable = createAction(
  FinancingActionType.UpdateIsFcisResultAvailable,
  props<{ isFcisResultAvailable: boolean }>()
);

export const financingFetchFcisVersion = createAction(
  FinancingActionType.FetchFcisVersion,
  props<{ fcisVersion: string }>()
);
